import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ListService } from './list.service';
import { GoogleAnalyticsService } from 'src/app/services/common/google-analytics.service';

@Component({
    selector: 'order-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: false
})
export class ListComponent implements OnInit {
  isMobile: boolean;

  constructor(
    private deviceService: DeviceDetectorService,
    public listService :ListService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.googleAnalyticsService.trackEvent('page_view', {
      page_title: 'My Orders',
      content_group: 'account',
      customer_type: 'returning'
    }).catch(error => console.error('AddGa4Event order history page_view failed: ', error));
  }
}
